export default __webpack_public_path__ + "static/media/change-over-time.5c631935.svg";